import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Routes, Route } from 'react-router-dom';
import { layoutTypes } from './constants/layout';
import { authProtectedRoutes, publicRoutes } from './routes';

import Authmiddleware from './routes/route';

import './assets/scss/theme.scss';

import fakeBackend from './helpers/AuthType/fakeBackend';
import VerticalLayout from 'layouts/authorized/verticalLayout';
import HorizontalLayout from 'layouts/authorized/horizontalLayout';
import NonAuthLayout from 'layouts/NonAuthLayout';
import ShopLayout from 'layouts/authorized/ShopLayout';

import 'handsontable/dist/handsontable.full.min.css';
import { registerAllModules } from 'handsontable/registry';
import { isSaaSSubdomain } from 'utils/getSubdomain';
registerAllModules();

const getLayout = (layoutType, isShopLayout) => {
  if (isShopLayout) {
    return ShopLayout;
  }
  
  return VerticalLayout;

  // if (isSaaSSubdomain()) {
  //   return VerticalLayout;
  // }
  // return HorizontalLayout;

  

  // switch (layoutType) {
  //   case layoutTypes.VERTICAL:
  //     return VerticalLayout;
  //   case layoutTypes.HORIZONTAL:
  //     return HorizontalLayout;
  //   default:
  //     return VerticalLayout;
  // }
};

const App = () => {
  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutType: layout.layoutType,
    }),
  );

  const { layoutType } = useSelector(LayoutProperties);

  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            exact={true}
          />
        ))}

        {authProtectedRoutes.map((route, idx) => {
          const isShopRoute = route?.layout === 'SHOP';
          const Layout = getLayout(layoutType, isShopRoute);

          return (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
              exact={true}
            />
          );
        })}
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
